import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'no-records',
  template: `
  <div class="flex">
    <i class="material-icons">view_headline</i>
    <div class="text">
        No Records Found
    </div>
  </div>`,
  styleUrls: ['./no-records.component.scss']
})
export class NoRecordsComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// /home/runner/work/slipresistant/slipresistant/client/src/app/no-records/no-records.component.ts